import { Component, ElementRef, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Empty_ExpertCalibration_Interface, ExpertCalibration_Interface } from 'src/app/Interface/ExpertCalibration_Interface';
import { Empty_General_Interface, General_Interface } from 'src/app/Interface/General_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { CalibrationService } from 'src/app/Service/Calibration/Calibration.service';

import { LabService } from 'src/app/Service/Lab/Lab.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';

@Component({
  selector: 'app-LabUploadDeviceForm',
  templateUrl: './LabUploadDeviceForm.component.html',
  styleUrls: ['./LabUploadDeviceForm.component.scss']
})
export class LabUploadDeviceFormComponent implements OnInit {

  @Input() inner_UploadDevice_id:number=0
  @Output() OnBack_UploadDevice_Action = new EventEmitter<number>();

  Procssing: boolean = false;
  FormSubmitted: boolean = false;


  constructor(
    private Lab_Service: LabService,
    private Alertify_Service: AlertifyService,
    private Nav_Service: NavService,
    private Calibration_Service: CalibrationService,
    private modalService: BsModalService
  ) { }

  ngOnInit() {
    var Menu_Id: number = 8
    if (this.inner_UploadDevice_id > 0)
      Menu_Id = 1134
    this.Nav_Service.CheckValidPage(Menu_Id).subscribe(
      data => {

      }
      , error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )
  }


  ResetForm(){
    this.FormSubmitted=false
    this.Info_Upload_List=[]
    this.QRCodeInputUpload.nativeElement['value']=''
  }

  On_Back() {
    this.OnBack_UploadDevice_Action.emit(1)
  }

  //#region Upload
  Info_Upload_List: Array<General_Interface> = []
  @ViewChild('QRCodeInputUpload') QRCodeInputUpload: ElementRef;

  QRCodeInputUpload_Enter() {
    this.Get_Calibration_Info_Upload(this.QRCodeInputUpload.nativeElement['value'])
  }

  Get_Calibration_Info_Upload(QRCodeInput: string) {

    if (!this.Procssing) {
      this.Procssing = true
      this.Calibration_Service.GetInfobyQR(QRCodeInput).subscribe(
        data => {

          this.Procssing = false
          this.QRCodeInputUpload_Esc()

          if (data.id == -1) {
            this.Alertify_Service.ErrorMessage("QR Code اسکن شده معتبر نمی باشد")
          }
          else if (this.Info_Upload_Exist(data)) {
            this.Alertify_Service.ErrorMessage("QR Code اسکن شده در لیست موجود است")
          }
          else {
            data.dsc=QRCodeInput
            this.Info_Upload_List.push(data)
            this.Alertify_Service.SuccessMessage("اطلاعات دستگاه خوانده شد")
          }

        }, error => {
          this.Procssing = false
          this.Alertify_Service.ErrorMessage("QR Code اسکن شده معتبر نمی باشد")

        }
      )
    }

  }

  QRCodeInputUpload_Esc() {
    this.QRCodeInputUpload.nativeElement['value'] = ''
  }

  Info_Upload_Exist(input: General_Interface) {
    for (let item of this.Info_Upload_List) {
      if (item.code == input.code) {
        return true
      }
    }
    return false
  }

  Info_Upload_Remove(id: number) {
    this.Info_Upload_List.splice(id, 1)
    this.Alertify_Service.SuccessMessage("حذف شد")
    this.QRCodeInputUpload.nativeElement.focus();
  }


  QRCodeChangeUpload() {
    this.Procssing = true

    var Code: Array<string> = []
    for (let item of this.Info_Upload_List) {
      Code.push(item.dsc)
    }

    this.Lab_Service.PostUpload(Code).subscribe(
      data => {

        this.Procssing = false
        this.QRCodeInputUpload_Esc()
        this.Info_Upload_List = data

        this.FormSubmitted=true
        this.Alertify_Service.SuccessMessage("دستگاه های برای خروج بررسی شد")

      }, error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }


  //#endregion

}
